<template>
    <div class="select-contract">
        <div class="select-contract__container">
            <h2 class="select-contract__headline" v-html="$t('SelectContract.select_agreement')"></h2>
            <TotemSelect class="select-contract__select"/>
            <h3 class="select-contract__title" v-html="$t('SelectContract.agreement_details')"></h3>
            <span class="select-contract__data">{{ $t("SelectContract.name") }} {{ contractDetails.name }}</span>
            <span class="select-contract__data">{{ $t("SelectContract.duration") }} {{ contractDetails.duration }}</span>
            <span class="select-contract__data">{{ $t("SelectContract.price") }} {{ contractDetails.price }}</span>
            <span class="select-contract__data">{{ $t("SelectContract.other_info") }} {{ contractDetails.otherInformation }}</span>
        </div>
        <AddUserForm />
    </div>
</template>

<script>
    import AddUserForm from 'components/user/selfserviceform/AddUserForm'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            AddUserForm
        },
        computed: {
            ...mapGetters({
                contractDetails: 'SelfServiceForm/getContractDetails'
            })
        },
        created () {
            this.$store.dispatch('SelfServiceForm/loadContractDetails')
        }
    }
</script>

<style lang="scss" scoped>
    .select-contract {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 0 40px;

        [class*="desktop_x"] & {
            width: 400px;
        }

        &__container {
            margin: 0 0 40px;
        }

        &__headline {
            margin: 0 0 20px;
        }

        &__select {
            margin: 0 0 40px;
        }

        &__title {
            font-size: 2.2rem;
            font-family: Nunito-Bold, sans-serif;
            margin: 0 0 20px;
        }

        &__data {
            font-size: 2rem;
            display: block;
        }
    }
</style>
